import { render, staticRenderFns } from "./WidgetColumnPreview.vue?vue&type=template&id=0c216ded"
import script from "./WidgetColumnPreview.vue?vue&type=script&lang=js"
export * from "./WidgetColumnPreview.vue?vue&type=script&lang=js"
import style0 from "./WidgetColumnPreview.vue?vue&type=style&index=0&id=0c216ded&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports